module.exports = __webpack_public_path__ + "img/huizhang.9c58bac7.png";